export default "__VITE_ASSET__Bs9CzqU0__"